import WhatsAppInbox from '../components/whatsapp/WhatsAppInbox';
export default function WhatsApp() {
  return <div className="space-y-4"><h1 className="text-2xl font-bold">Chat WhatsApp</h1><div className="h-[calc(100dvh-12rem)] min-h-[400px] overflow-hidden rounded-xl border"><WhatsAppInbox /></div></div>;
}
